;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);
	var product = window.product;
	var $product;

	$doc.ready(function() {
		$product = $('#product');

		// Label focus move
		$('.field, .textarea').on('keydown keyup', function() {
			var $field = $(this),
				$parent = $field.parent(),
				$label = $field.prev('label');

			if ($label.length) {
				$parent.toggleClass('form-show-label', Boolean($field.val().length) );
			};

		}).each(function() {
			var $field = $(this),
				$parent = $field.parent(),
				$label = $field.prev('label');

			if ($label.length) {
				$parent.toggleClass('form-show-label', Boolean($field.val().length) );
			};

		});

		// Mobile Menu

		$('.btn-menu').on('click', function (event) {
			$(this).toggleClass('active').closest('body').toggleClass('header-visible');
			event.preventDefault();
		});

		
			// Product Popup
			$('.link-popup').magnificPopup({
				type: "image",
				gallery: {
					enabled: true
				}
			});

		

		// Product Slider
		


		$('.addresses .cancel').on('click', function(event) {
			var $section = $(this).closest('.accordion-section');

			$section.find('.accordion-body').slideUp();

			event.preventDefault();
		});

		$('.btn-new-adress, .form-add-address .cancel').on('click', function(event) {

			$('.form-add-address').slideToggle();

			event.preventDefault();
		});

		// Variants listing logic - [Radio/Select]
		
			var $select = $('#product-select');
			if ($select.length) {
				$('.radio-variants input').on('change', function() {
					var productPriceHolder = $('.product-price');
					var dataSelector = ''
					$(this).closest('.radio-variants').find('input:checked').each(function() {
						var $this = $(this);
						dataSelector += '[data-'+ $this.data('type') +'="' +  $this.val() + '"]';
					})
					if ($(dataSelector).length && $(dataSelector).attr('disabled') != 'disabled' ) {
						productPriceHolder.text($(dataSelector).data('price'));
						$('#AddToCart').prop('disabled', false)
					}else{
						$('#AddToCart').prop('disabled', true)
						productPriceHolder.text('Sold Out');
					}
					$select.val($(dataSelector).val());
				})
				$select.hide();

				var options = $select.data('options');
				var splitOptions = options.split(',');
				var selectedOption = $select.find('option:selected');

				for(var i in splitOptions){
					$('#radio-'+ splitOptions[i].toLowerCase().replace(' ', '-') + '-' + selectedOption.data(splitOptions[i]) ).prop('checked', true)
				}
			};

		


	});

	Shopify.CustomerAddress = {
		toggleForm: function(address_id) {
			var $form = $('#address_form_' + address_id),
				$section = $form.closest('.accordion-section');

			$section.find('.accordion-body').slideToggle();

			return false;
		},

		destroy: function(id, confirm_msg) {
			if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
				Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
			}
		}
	}
})(jQuery, window, document);
